module.exports = __webpack_public_path__ + "static/media/asui-tsuyu.307ec528.png";